import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../../../button";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

const PlanSuccessModal = ({ isSuccessOpen, handleClose }) => {
  return (
    <Transition.Root show={isSuccessOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-[10px] bg-white px-0 md:px-[20px] py-6 text-left shadow-xl transition-all sm:my-8 w-full max-w-[400px]">
                <div className="flex items-center justify-center gap-5 px-[20px] flex-col">
                  <CheckCircleIcon className="w-12 h-12 text-[#16CA7C]" />
                  <p className="text-lg font-medium leading-[160%]">
                    Your plan was successfully modified.
                  </p>
                  <Button
                    title="Close"
                    type="button"
                    classes="bg-primary w-full max-w-[130px] py-2 flex justify-center items-center text-sm md:text-base uppercase font-black leading-[160%] rounded-md text-white duration-500"
                    onClick={handleClose}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default PlanSuccessModal;
